import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";

import UserService from "../../services/user.service";

import { Form, FloatingLabel } from "react-bootstrap";

import "../../assets/css/datatable.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import ReportService from "../../services/report.service";

import CourseService from "../../services/course.service";
import AuthService from "../../services/auth.service";
import CartService from "../../services/cart.service";

const PaymentHistoryReport = () => {
  const [paymentHistorys, setPaymentHistorys] = useState([]);

  const [courses, setCourses] = useState([]);

  const [roleid, setRoleId] = useState("");

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    setRoleId(user.role_id);
    CourseService.getCourse(user.user)
      .then((resp) => setCourses(resp.data))
      .catch((e) => console.log(e));
  }, []);

  const loadDatatable = () => {
    if (!$.fn.DataTable.isDataTable("#allLearners")) {
      function filterGlobal() {
        $("#allLearners")
          .DataTable()
          .search(
            $("#global_filter").val(),
            $("#global_regex").prop("checked"),
            $("#global_smart").prop("checked")
          )
          .draw();
      }
      function filterColumn(i) {
        $("#allLearners")
          .DataTable()
          .column(i)
          .search(
            $("#col" + i + "_filter").val(),
            $("#col" + i + "_regex").prop("checked"),
            $("#col" + i + "_smart").prop("checked")
          )
          .draw();
      }

      $.fn.dataTable.ext.search.pop();

      function filterByCourses(coursename) {
        $.fn.dataTable.ext.search.pop();

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
          var rowData = data[1];
          if (rowData === coursename) {
            return true;
          }
          return false;
        });

        $("#allLearners").DataTable().draw();
      }

      function compareDates() {
        $.fn.dataTable.ext.search.pop();

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
          var minDate = $("#minDate").val();
          var maxDate = $("#maxDate").val();

          let date = data[7];

          if (minDate === date || (minDate <= date && date <= maxDate)) {
            return true;
          }
          return false;

          // if (
          //   (minDate === null && maxDate === null) ||
          //   (minDate === null && date <= maxDate) ||
          //   (minDate <= date && maxDate === null) ||
          //   (minDate <= date && date <= maxDate)
          // ) {
          //   return true;
          // }
          // return false;
        });

        $("#allLearners").DataTable().draw();

        // Clear the custom filter if the date input is empty
        if (!$(this).val()) {
          $.fn.dataTable.ext.search.pop();
        }
      }

      $("#minDate, #maxDate").on("change", function () {
        compareDates();
      });

      $("#filterByCourse").on("change", function () {
        var selectedValue = $(this).val();

        if (selectedValue === "0") {
          $.fn.dataTable.ext.search.pop();
          $("#allLearners").DataTable().draw();
        } else {
          filterByCourses(selectedValue);
        }
      });

      $("#clearFilter").on("click", function () {
        $.fn.dataTable.ext.search.pop();
        $("#allLearners").DataTable().draw();
        $("#minDate").val("");
        $("#maxDate").val("");
      });

      $(document).ready(function () {
        setTimeout(function () {
          $("#allLearners").DataTable({
            pagingType: "full_numbers",
            responsive: true,
            pageLength: 10,
            select: true,
            bDestroy: true,
            dom: "Bfrtip",

            buttons: [
              {
                extend: "csv",
                text: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 42.975 46">
              <g id="Layer_2" data-name="Layer 2" transform="translate(0)">
                <g id="Layer_1" data-name="Layer 1" transform="translate(0 0)">
                  <path id="Path_11501" data-name="Path 11501" d="M37.361,46H13.149a1.579,1.579,0,0,0-.248-.081,6.269,6.269,0,0,1-5.314-5.769c-.1-1.805-.04-3.621-.05-5.431v-.57H2.157A1.964,1.964,0,0,1,0,32.007Q0,26.572,0,21.14a1.985,1.985,0,0,1,2.179-2.171H7.534v-.641c0-3.936-.02-7.874.007-11.81A6.231,6.231,0,0,1,11.446.507,12.158,12.158,0,0,1,13.149,0H29.2c.133.12.274.225.4.35q6.515,6.524,13.018,13.057a1.3,1.3,0,0,1,.344.825q.025,12.688,0,25.374a6.314,6.314,0,0,1-5.049,6.252C37.734,45.905,37.545,45.954,37.361,46ZM8.97,18.968h23.3a2.028,2.028,0,0,1,2.284,2.294c0,3.518-.03,7.037.014,10.555a2.16,2.16,0,0,1-2.344,2.348c-7.547-.04-15.094-.018-22.641-.018H9.015a1.511,1.511,0,0,0-.041.223c0,1.781-.056,3.565.017,5.344a4.876,4.876,0,0,0,5.1,4.847H36.417a5.686,5.686,0,0,0,1.33-.14,4.924,4.924,0,0,0,3.794-5.06V15.282c0-.161-.013-.32-.023-.526H30.687a2.189,2.189,0,0,1-2.453-2.469V1.437h-.359q-6.993,0-13.987.007a4.847,4.847,0,0,0-1.15.144A4.915,4.915,0,0,0,8.968,6.62q-.011,5.928,0,11.859ZM17.3,21.963v.044c-.24,0-.479-.008-.719,0a2.61,2.61,0,0,0-2.463,2.357A2.372,2.372,0,0,0,16.04,27.12,12.612,12.612,0,0,0,17.6,27.3a1.2,1.2,0,0,1,1.114,1.142A1.169,1.169,0,0,1,17.7,29.663a7.7,7.7,0,0,1-1.116.041c-.692,0-.924-.206-1.063-.89a.723.723,0,0,0-.8-.667.737.737,0,0,0-.612.851,2.188,2.188,0,0,0,1.882,2.086,8.807,8.807,0,0,0,1.829.013,2.6,2.6,0,0,0,2.326-2.717,2.635,2.635,0,0,0-2.5-2.516,8.922,8.922,0,0,1-1.2-.111.963.963,0,0,1-.906-1.164,1.171,1.171,0,0,1,1.113-1.137c.387-.02.776-.014,1.164,0a.824.824,0,0,1,.9.8c.08.506.359.77.785.733a.751.751,0,0,0,.643-.91,2.223,2.223,0,0,0-1.6-1.957,7.384,7.384,0,0,0-1.245-.157ZM6.756,26.576h.037c0,.553-.02,1.108,0,1.66a3.021,3.021,0,0,0,5.942.635,2.5,2.5,0,0,0,.09-.839.642.642,0,0,0-.685-.63.663.663,0,0,0-.709.606c-.019.1-.023.207-.041.31A1.59,1.59,0,0,1,8.224,28.1c-.016-1.017-.042-2.036.016-3.05a2.1,2.1,0,0,1,.426-1.09,1.4,1.4,0,0,1,1.621-.448,1.591,1.591,0,0,1,1.136,1.508.693.693,0,0,0,.789.713.729.729,0,0,0,.629-.839,3.046,3.046,0,0,0-2.7-2.882A2.973,2.973,0,0,0,6.87,24.43a19.606,19.606,0,0,0-.114,2.144Zm17.729,1.557c-.28-.839-.521-1.557-.759-2.282l-1.084-3.275c-.108-.325-.311-.6-.664-.551a1,1,0,0,0-.662.4,1.07,1.07,0,0,0,.024.762c.785,2.414,1.592,4.82,2.385,7.232.126.382.3.7.75.708s.638-.305.763-.69q.638-1.961,1.289-3.915c.393-1.191.794-2.378,1.179-3.572a.709.709,0,0,0-.426-.914.719.719,0,0,0-.914.435c-.053.12-.087.254-.131.381Z" fill="#128fc5"/>
                </g>
              </g>
            </svg>
            `,
                className: "rep-down-btns",
                filename: "Activity Result Report",
              },
              {
                extend: "excel",
                text: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 43.117 46">
              <g id="Layer_2" data-name="Layer 2" transform="translate(0 -0.013)">
                <g id="Layer_1" data-name="Layer 1" transform="translate(0 0.013)">
                  <path id="Path_11511" data-name="Path 11511" d="M7.569,19H2.378C.719,19,0,19.71,0,21.349V31.839a2.038,2.038,0,0,0,2.333,2.333H7.566V39.71A6.369,6.369,0,0,0,13.837,46q11.47.034,22.945,0a6.285,6.285,0,0,0,6.309-6.318c.048-8.455.019-16.907,0-25.362a1.483,1.483,0,0,0-.4-.944Q36.229,6.872,29.731.422A1.581,1.581,0,0,0,28.72.034Q21.317,0,13.9.025A6.326,6.326,0,0,0,7.576,6.393c-.022,3.9,0,7.808,0,11.71Zm1.437,0V6.7a4.931,4.931,0,0,1,5.269-5.241H28.313V12.18c0,1.82.8,2.606,2.635,2.608H41.675V39.365a4.936,4.936,0,0,1-5.248,5.207H14.043a4.9,4.9,0,0,1-5.03-4.979c-.017-1.6,0-3.209,0-4.814,0-.184.034-.366.057-.6H32.265c1.66,0,2.376-.719,2.378-2.347V21.406c0-1.736-.683-2.41-2.448-2.41H9.011ZM21.207,22c1.739,0,2.754.719,2.9,2,.057.5-.1.9-.606.98-.479.074-.668-.271-.836-.7a1.449,1.449,0,0,0-.745-.8,3.387,3.387,0,0,0-1.423,0,1.175,1.175,0,0,0-.987,1.293c0,.683.4.932.982,1.008.426.055.857.074,1.286.12A2.635,2.635,0,0,1,24.1,28.189a2.471,2.471,0,0,1-1.691,2.759A7.288,7.288,0,0,1,19.585,31,1.917,1.917,0,0,1,18.1,29.248c-.069-.479-.048-.958.57-1.042.546-.077.69.307.872.747a1.449,1.449,0,0,0,.8.745,2.992,2.992,0,0,0,1.279,0,1.166,1.166,0,0,0,1.068-1.224,1.2,1.2,0,0,0-1.162-1.159c-.429-.046-.862-.06-1.286-.125a2.493,2.493,0,0,1-1.959-3.562A2.713,2.713,0,0,1,21.207,22Zm6.579,5.988c-.534.884-1.037,1.691-1.514,2.515-.285.479-.637.857-1.2.493s-.285-.826-.024-1.255c.52-.857,1.018-1.732,1.562-2.572a.906.906,0,0,0,.019-1.154c-.57-.855-1.068-1.756-1.6-2.635-.268-.441-.479-.891.091-1.241s.872.065,1.133.493l1.533,2.539c.546-.9,1.042-1.713,1.535-2.532.259-.434.548-.862,1.126-.513s.374.8.105,1.238c-.558.92-1.1,1.851-1.677,2.759a.719.719,0,0,0,0,.9c.541.845,1.044,1.713,1.562,2.572.448.745.462,1.222,0,1.437-.673.307-.939-.192-1.217-.659-.448-.781-.917-1.55-1.435-2.4Zm-20.907,0c-.558.925-1.049,1.713-1.516,2.517-.268.46-.6.829-1.142.527s-.386-.786-.108-1.236c.537-.874,1.037-1.775,1.6-2.635a.917.917,0,0,0,0-1.147C5.111,25.095,4.558,24.146,4,23.2a.7.7,0,0,1,.2-1.063c.438-.275.771-.048,1.023.321.2.3.369.613.556.92.35.575.7,1.15,1.1,1.8.525-.872.958-1.612,1.413-2.34.28-.448.515-1.111,1.231-.7s.295.934.012,1.406c-.479.8-.922,1.622-1.451,2.4a1.031,1.031,0,0,0,.022,1.339c.544.812,1.016,1.677,1.528,2.51.268.441.479.905-.074,1.238s-.879,0-1.152-.479c-.472-.838-.984-1.645-1.53-2.565Zm4.378-1.418V24.992a21.465,21.465,0,0,1,.024-2.227,1.075,1.075,0,0,1,.565-.719c.16-.074.553.125.7.311a1.289,1.289,0,0,1,.125.757c0,1.988.019,3.976,0,5.962,0,.5.146.673.651.654.982-.034,1.966,0,2.948,0,.522,0,1.037.069,1.039.7s-.505.733-1.028.733H12.33c-.843,0-1.068-.24-1.075-1.071C11.238,28.917,11.257,27.746,11.257,26.572Z" transform="translate(0 -0.013)" fill="#15925a"/>
                </g>
              </g>
            </svg>
            `,
                className: "rep-down-btns",
                filename: "Activity Result Report",
              },
              {
                extend: "pdf",
                text: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 43.032 46">
              <g id="Layer_2" data-name="Layer 2" transform="translate(-0.001)">
                <g id="Layer_1" data-name="Layer 1" transform="translate(0.001 0)">
                  <path id="Path_11508" data-name="Path 11508" d="M7.558,18.987H2.351c-1.6,0-2.351.72-2.351,2.3V31.85a2.024,2.024,0,0,0,2.282,2.308H7.543v.82c0,1.581-.014,3.162,0,4.74a6.321,6.321,0,0,0,6.276,6.266q11.456.041,22.91,0a6.283,6.283,0,0,0,6.278-6.34c.043-8.428.019-16.857,0-25.285a1.674,1.674,0,0,0-.435-1.055Q36.179,6.847,29.729.456A1.674,1.674,0,0,0,28.653.028Q21.286-.01,13.932.016A6.326,6.326,0,0,0,7.563,6.409c-.017,3.9,0,7.8,0,11.719Zm1.435,0V6.686a4.927,4.927,0,0,1,5.262-5.238H28.27V12.1c0,1.913.77,2.676,2.71,2.676H41.587v9.916c0,4.884.012,9.77,0,14.654a4.94,4.94,0,0,1-5.243,5.207H14.011a4.9,4.9,0,0,1-5.023-4.982c-.017-1.6,0-3.207,0-4.812,0-.182.036-.366.06-.6H32.209c1.653,0,2.37-.718,2.37-2.346,0-3.4-.062-6.8.026-10.2.05-1.913-.957-2.662-2.614-2.648-7.35.055-14.7.024-22.049.024Zm5.214,7.589V22.912a.8.8,0,0,1,.916-.921c.741,0,1.485-.022,2.224,0a2.978,2.978,0,0,1,2.887,2.978c.014,1.076.017,2.153,0,3.231a2.839,2.839,0,0,1-2.516,2.844,21.234,21.234,0,0,1-2.648.086c-.612,0-.883-.347-.868-.973C14.224,28.97,14.207,27.772,14.207,26.576ZM7.893,28.159v2.057c0,.5-.158.88-.7.89s-.737-.368-.737-.863V22.924c0-.605.27-.942.909-.933.741,0,1.485-.019,2.224,0a3.083,3.083,0,0,1-.05,6.159C9.026,28.174,8.5,28.159,7.893,28.159ZM23.53,26.877v3.279c0,.519-.151.94-.718.957s-.718-.414-.718-.938V23c0-.792.218-1,1.036-1h3.657c.557,0,1.287-.141,1.308.7s-.718.718-1.272.718H23.566v2.019h2.963c.519,0,1.024.057,1.014.718s-.5.732-1.024.729C25.551,26.873,24.577,26.877,23.53,26.877Z" transform="translate(0 -0.005)" fill="#ff2116"/>
                  <path id="Path_11509" data-name="Path 11509" d="M65.49,97.947v6.314a15.028,15.028,0,0,0,2.052-.153,1.315,1.315,0,0,0,1.076-1.344c.026-1.122.029-2.246,0-3.368A1.507,1.507,0,0,0,67.2,97.962,16.034,16.034,0,0,0,65.49,97.947Z" transform="translate(-49.827 -74.51)" fill="#ff2116"/>
                  <path id="Path_11510" data-name="Path 11510" d="M33.16,97.909v3.286a17.223,17.223,0,0,0,1.8-.012,1.649,1.649,0,0,0-.148-3.267C34.286,97.882,33.76,97.909,33.16,97.909Z" transform="translate(-25.229 -74.485)" fill="#ff2116"/>
                </g>
              </g>
            </svg>
            `,
                className: "rep-down-btns",
                filename: "Activity Result Report",
              },
            ],

            lengthMenu: [
              [10, 20, 30, 50, -1],
              [10, 20, 30, 50, "All"],
            ],
            columnDefs: [
              {
                targets: 0,
                render: function (data, type, row, meta) {
                  return type === "export" ? meta.row + 1 : data;
                },
              },
            ],
            order: [[0, "desc"]],
          });

          $("input.global_filter").on("keyup click", function () {
            filterGlobal();
          });

          $("input.column_filter").on("keyup click", function () {
            filterColumn($(this).parents("tr").attr("data-column"));
          });
        }, 0);
      });
    }
  };

  const getActivityResultCount = () => {
    const user = AuthService.getCurrentUser();
    if (user.role_id === "4") {
      CartService.getPayHistory()
        .then((res) => {
          setPaymentHistorys(res.data);
          loadDatatable();
        })
        .catch((e) => console.log(e));
    } else {
      CartService.getAllPayHistory()
        .then((res) => {
          setPaymentHistorys(res.data);

          loadDatatable();
        })
        .catch((e) => console.log(e));
    }
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      getActivityResultCount(user.user);
    }
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="box-outer right">
              <div className="box-inner">
                <div className="action-flex">
                  <div className="heading">
                    <h1>
                      {roleid === "4"
                        ? "Transaction History"
                        : "Payment History Report"}
                    </h1>
                  </div>
                  <div className="courses-act">
                    <div className="action-item">
                      <Link to="/Reports">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 19.379 19.382"
                          >
                            <g
                              id="left-arrow-in-circular-button-black-symbol"
                              transform="translate(-0.6 511.567)"
                            >
                              <path
                                id="Path_13057"
                                data-name="Path 13057"
                                d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                                transform="translate(0 0)"
                              />
                            </g>
                          </svg>
                        </span>
                        &nbsp;&nbsp;
                        <span>Back</span>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="filter reports">
                  <div className="filter-heading">
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.432"
                        height="15.819"
                        viewBox="0 0 24.503 22.236"
                      >
                        <g
                          id="setting-_1_"
                          transform="translate(-21.408 468.876)"
                        >
                          <path
                            id="Path_12194"
                            data-name="Path 12194"
                            d="M365.507-468.8A3.342,3.342,0,0,0,363-465.566a3.082,3.082,0,0,0,.366,1.541,3.339,3.339,0,0,0,3.338,1.781,3.279,3.279,0,0,0,2.016-1.008,3.023,3.023,0,0,0,.742-1.175,3.384,3.384,0,0,0-.935-3.646,4.2,4.2,0,0,0-1.426-.731A4.3,4.3,0,0,0,365.507-468.8Z"
                            transform="translate(-323.75 0)"
                          />
                          <path
                            id="Path_12195"
                            data-name="Path 12195"
                            d="M22.212-426.671a1.244,1.244,0,0,0-.428.261,1.076,1.076,0,0,0,.235,1.786l.277.136h6.863c5.281,0,6.916-.016,7.083-.063a1.188,1.188,0,0,0,.705-.736,1.117,1.117,0,0,0-.507-1.275l-.245-.146-6.895-.01C24.86-426.723,22.337-426.707,22.212-426.671Z"
                            transform="translate(0 -39.955)"
                          />
                          <path
                            id="Path_12196"
                            data-name="Path 12196"
                            d="M28.6-319.677a3.464,3.464,0,0,0-2.236,1.734l-.225.434h-1.88a8.787,8.787,0,0,0-2.074.078,1.114,1.114,0,0,0,0,2.037,8.787,8.787,0,0,0,2.074.078h1.88l.225.428a3.339,3.339,0,0,0,3.15,1.8,3.343,3.343,0,0,0,2.988-2.309,2.628,2.628,0,0,0,.136-1.019,2.593,2.593,0,0,0-.141-1.029,3.359,3.359,0,0,0-2.131-2.142A3.734,3.734,0,0,0,28.6-319.677Z"
                            transform="translate(-0.111 -141.345)"
                          />
                          <path
                            id="Path_12197"
                            data-name="Path 12197"
                            d="M278.32-276.916a1.113,1.113,0,0,0,.094,2.058c.136.042,1.661.052,4.931.042l4.732-.016.23-.157a1.109,1.109,0,0,0-.178-1.933,38.806,38.806,0,0,0-4.91-.078A39.328,39.328,0,0,0,278.32-276.916Z"
                            transform="translate(-242.883 -181.854)"
                          />
                          <path
                            id="Path_12198"
                            data-name="Path 12198"
                            d="M280.146-170.548a3.075,3.075,0,0,0-1.88.966,3.127,3.127,0,0,0-1,2.142,3.272,3.272,0,0,0,.935,2.5,3.089,3.089,0,0,0,2.209,1.008,3.24,3.24,0,0,0,1.708-.334,3.779,3.779,0,0,0,1.447-1.463l.183-.376,1.807-.005c2.11,0,2.215-.016,2.544-.4a1.073,1.073,0,0,0-.308-1.713l-.277-.136h-3.782l-.063-.188a3.569,3.569,0,0,0-1.588-1.687A3.532,3.532,0,0,0,280.146-170.548Z"
                            transform="translate(-242.489 -282.716)"
                          />
                          <path
                            id="Path_12199"
                            data-name="Path 12199"
                            d="M22.06-127.864a1.075,1.075,0,0,0-.575,1.243,1.2,1.2,0,0,0,.789.8c.178.047,1.473.063,4.758.063,5.124,0,4.889.016,5.249-.4a1.073,1.073,0,0,0-.308-1.713L31.7-128h-9.36Z"
                            transform="translate(-0.042 -323.071)"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="name">Filters</span>
                  </div>
                  <p id="clearFilter">Clear Filter</p>
                </div>
                <div className="search-bar form-flex">
                  <input
                    type="text"
                    className="global_filter"
                    id="global_filter"
                    placeholder="Start typing to search..."
                  />
                  <Form.Group
                    // controlId="formBasicOrgName"
                    className="date-input"
                  >
                    <div className="input-box">
                      <Form.Select type="date" name="" id="filterByCourse">
                        <option value={0}>Select Course</option>
                        {Array.isArray(courses)
                          ? courses.map((course) => {
                              return (
                                <option key={course.id} value={course.name}>
                                  {course.name}
                                </option>
                              );
                            })
                          : null}
                      </Form.Select>
                    </div>
                  </Form.Group>
                  <Form.Group
                    // controlId="formBasicOrgName"
                    className="date-input"
                  >
                    <div className="input-box">
                      <FloatingLabel
                        // controlId="floatingInput"
                        label="From Date"
                        className="mb-3"
                      >
                        <Form.Control type="date" name="minDate" id="minDate" />
                      </FloatingLabel>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="14.02"
                          viewBox="0 0 81.923 76.58"
                        >
                          <g id="calendar" transform="translate(-15 482)">
                            <path
                              id="Path_13206"
                              data-name="Path 13206"
                              d="M20.071-481.763a6.872,6.872,0,0,0-4.139,3.494c-.8,1.577-.933,2.68-.933,8.175v5.054H96.77l-.051-5.394-.051-5.377-.543-1.153a9.468,9.468,0,0,0-6.31-4.8A33.656,33.656,0,0,0,84.592-482H80.47v3.85a39.256,39.256,0,0,1-.17,4.461,3,3,0,0,1-.763,1.187,1.965,1.965,0,0,1-1.476.645,1.8,1.8,0,0,1-1.476-.339c-1.289-.882-1.289-.865-1.34-5.58L75.179-482H34.505v3.681c-.017,4.427-.1,4.987-.9,5.767a2.54,2.54,0,0,1-3.9-.441c-.356-.577-.373-.814-.424-4.817L29.23-482l-4.189.017A31.215,31.215,0,0,0,20.071-481.763Z"
                            />
                            <path
                              id="Path_13207"
                              data-name="Path 13207"
                              d="M15.034-326.627l.051,24.39.441,1.119a6.553,6.553,0,0,0,4.122,4.172c.814.288,2.612.305,35.551.305H89.884l1.136-.39a9.341,9.341,0,0,0,5.275-4.444l.543-1.1.051-24.2L96.923-351H15ZM38.9-341.281a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.935.051,3.155.034,3.528-.271,4.223-.594,1.34-.746,1.374-5.054,1.374-5.343,0-5.156.2-5.156-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,38.9-341.281Zm20.184,0a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.986.068,3.9-.051,4.58-.865,5.19-.458.339-.7.356-4.359.356-5.462,0-5.258.22-5.258-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,59.082-341.281Zm20.54.034c.933.492,1.018.882,1.018,5,0,5.445.271,5.173-5.241,5.173-3.731,0-3.85-.017-4.376-.39-.78-.56-.9-1.187-.9-4.919,0-3.562.1-4.1.933-4.749.458-.356.628-.373,4.274-.373C78.4-341.5,79.232-341.451,79.622-341.247ZM39.2-318.129c.78.56.9,1.187.9,4.834,0,3.46-.1,3.935-.916,4.7-.458.424-.475.424-4.274.475-3.613.051-3.85.034-4.376-.305-.916-.56-.967-.882-.916-5.139.051-3.782.051-3.833.458-4.257a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C38.508-318.519,38.678-318.5,39.2-318.129Zm20.082-.085c.848.577.916.9.916,4.851a36.048,36.048,0,0,1-.136,4.139,1.659,1.659,0,0,1-.678.8c-.492.305-.865.339-4.325.339-5.563,0-5.326.237-5.258-5.428.051-3.85.051-3.884.458-4.308a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C58.37-318.519,58.9-318.485,59.286-318.214Zm19.845-.221a2.965,2.965,0,0,1,1.018.611l.407.441v8.277l-.475.458-.458.475H71.345l-.441-.407c-.712-.678-.814-1.34-.746-5.139.068-4.953-.017-4.868,5.139-4.868A28.455,28.455,0,0,1,79.131-318.434Z"
                              transform="translate(0 -108.781)"
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </Form.Group>
                  <Form.Group
                    // controlId="formBasicOrgName"
                    className="date-input"
                  >
                    <div className="input-box">
                      <FloatingLabel
                        // controlId="floatingInput"
                        label="To Date"
                        className="mb-3"
                      >
                        <Form.Control type="date" name="maxDate" id="maxDate" />
                      </FloatingLabel>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="14.02"
                          viewBox="0 0 81.923 76.58"
                        >
                          <g id="calendar" transform="translate(-15 482)">
                            <path
                              id="Path_13206"
                              data-name="Path 13206"
                              d="M20.071-481.763a6.872,6.872,0,0,0-4.139,3.494c-.8,1.577-.933,2.68-.933,8.175v5.054H96.77l-.051-5.394-.051-5.377-.543-1.153a9.468,9.468,0,0,0-6.31-4.8A33.656,33.656,0,0,0,84.592-482H80.47v3.85a39.256,39.256,0,0,1-.17,4.461,3,3,0,0,1-.763,1.187,1.965,1.965,0,0,1-1.476.645,1.8,1.8,0,0,1-1.476-.339c-1.289-.882-1.289-.865-1.34-5.58L75.179-482H34.505v3.681c-.017,4.427-.1,4.987-.9,5.767a2.54,2.54,0,0,1-3.9-.441c-.356-.577-.373-.814-.424-4.817L29.23-482l-4.189.017A31.215,31.215,0,0,0,20.071-481.763Z"
                            />
                            <path
                              id="Path_13207"
                              data-name="Path 13207"
                              d="M15.034-326.627l.051,24.39.441,1.119a6.553,6.553,0,0,0,4.122,4.172c.814.288,2.612.305,35.551.305H89.884l1.136-.39a9.341,9.341,0,0,0,5.275-4.444l.543-1.1.051-24.2L96.923-351H15ZM38.9-341.281a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.935.051,3.155.034,3.528-.271,4.223-.594,1.34-.746,1.374-5.054,1.374-5.343,0-5.156.2-5.156-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,38.9-341.281Zm20.184,0a2.562,2.562,0,0,1,.763.678c.322.441.356.746.407,3.986.068,3.9-.051,4.58-.865,5.19-.458.339-.7.356-4.359.356-5.462,0-5.258.22-5.258-5.224,0-5.411-.22-5.19,5.173-5.19A16.623,16.623,0,0,1,59.082-341.281Zm20.54.034c.933.492,1.018.882,1.018,5,0,5.445.271,5.173-5.241,5.173-3.731,0-3.85-.017-4.376-.39-.78-.56-.9-1.187-.9-4.919,0-3.562.1-4.1.933-4.749.458-.356.628-.373,4.274-.373C78.4-341.5,79.232-341.451,79.622-341.247ZM39.2-318.129c.78.56.9,1.187.9,4.834,0,3.46-.1,3.935-.916,4.7-.458.424-.475.424-4.274.475-3.613.051-3.85.034-4.376-.305-.916-.56-.967-.882-.916-5.139.051-3.782.051-3.833.458-4.257a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C38.508-318.519,38.678-318.5,39.2-318.129Zm20.082-.085c.848.577.916.9.916,4.851a36.048,36.048,0,0,1-.136,4.139,1.659,1.659,0,0,1-.678.8c-.492.305-.865.339-4.325.339-5.563,0-5.326.237-5.258-5.428.051-3.85.051-3.884.458-4.308a2.607,2.607,0,0,1,.933-.611,33.768,33.768,0,0,1,4.088-.119C58.37-318.519,58.9-318.485,59.286-318.214Zm19.845-.221a2.965,2.965,0,0,1,1.018.611l.407.441v8.277l-.475.458-.458.475H71.345l-.441-.407c-.712-.678-.814-1.34-.746-5.139.068-4.953-.017-4.868,5.139-4.868A28.455,28.455,0,0,1,79.131-318.434Z"
                              transform="translate(0 -108.781)"
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </Form.Group>
                </div>
                <div className="admin-users">
                  <div className="table-responsive">
                    <table className="table" id="allLearners">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Course Name</th>
                          <th>Price</th>
                          <th>Transacation Id</th>
                          <th>Payment Id</th>
                          <th>Payment Status</th>
                          <th>Paymemt Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(paymentHistorys)
                          ? paymentHistorys.map((paymentHistory, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <span>{paymentHistory.learnername}</span>
                                  </td>
                                  <td>
                                    <span>{paymentHistory.corsname}</span>
                                  </td>
                                  <td>
                                    <span>{paymentHistory.amount}</span>
                                  </td>
                                  <td>
                                    <span>{paymentHistory.transID}</span>
                                  </td>
                                  <td>
                                    <span>{paymentHistory.payid}</span>
                                  </td>
                                  <td>
                                    <span className={paymentHistory.res_sts}>
                                      {paymentHistory.res_sts === "CAPTURED"
                                        ? "Success"
                                        : paymentHistory.res_sts}
                                    </span>
                                  </td>
                                  <td>
                                    <span>{paymentHistory.transdate}</span>
                                  </td>
                                </tr>
                              );
                            })
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentHistoryReport;
